<template>
    <div id="pageTable">
        <v-container
            class="d-flex align-center justify-center"
            style="height: 80vh; width: 80vw;"
            v-if="rol != 'root' && rol != 'admin' && rol != 'admin-empresa'"
        >
            <v-card class="" style="border-radius:20px" max-width="500">
                <v-card-title class="justify-center card_titulo">
                    <div class="headerModal">
                        <img :src="'/static/icon/peligro.svg'" class="imgModal"/>
                    </div>
                </v-card-title>
                <v-card-text class="titleModal text-center">
                    Esta vista no esta disponible para este rol de usuario.
                </v-card-text>
                <v-card-actions class="d-flex align-center justify-center card_accion">
                    <v-btn
                        class="btnGuardar"
                        @click="redireccionar()"
                    >
                        Ok
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-container>
        <v-container xl fluid v-else>
            <v-row>
                <v-overlay :value="overlay">
                    <div class="align-center justify-center text-center">
                        <v-progress-circular
                            indeterminate
                            :size="100"
                            :width="7"
                            color="#2DB9D1">
                            <v-img
                                src="/static/icon/favicon.ico"
                                :width="60">
                            </v-img>
                        </v-progress-circular>
                        <p class="mt-5">{{ fraseOverlay }}</p>
                    </div>
                </v-overlay>
                <v-col cols="12" xs="12" sm="12" md="12" class="center">
                    <div class="margen d-flex">
                        <hr class="vr"/>
                        <p class="tblName">{{ nombre_tipo_reporte }}</p>
                    </div>
                    <v-card class="borde-card big elevation-0">
                        <v-card-text class="pa-5">
                            <ValidationObserver ref="form" v-slot="{ invalid }">
                                <v-row>
                                    <v-col cols="12" class="d-flex justify-end align-center text-center">
                                        <div class="text-exportar">
                                            Exportar en
                                        </div>
                                        <v-btn
                                            color="#FFFFFF"
                                            @click="generarReporte('xlsx')"
                                            right
                                            rounded
                                            class="btnReportes elevation-0 mr-1"
                                            :disabled="invalid || isFormBusy"
                                        >
                                            <img src="/static/icon/xls.png" style="width:28px" />
                                        </v-btn>
                                        <v-btn
                                            rounded
                                            class="btnReportes btnBorrar elevation-0"
                                            @click="resetValues()"
                                            :disabled="isFormBusy"
                                        >
                                            Borrar campos
                                        </v-btn>
                                    </v-col>
                                    <v-col v-if="rol == 'root'" cols="12" xs="12" sm="2" md="2" class="pb-0 ma-0">
                                        <ValidationProvider v-slot="{ errors }" name="Cliente" rules="required">
                                            <v-autocomplete
                                                outlined
                                                label="Clientes"
                                                :items="clientes"
                                                item-text="nombre"
                                                item-value="id"
                                                persistent-hint
                                                v-model="cliente_value"
                                                class="pa-0 ma-0"
                                                required
                                                :error-messages="errors"
                                                :disabled="isFormBusy"
                                            />
                                        </ValidationProvider>
                                    </v-col>
                                    <v-col v-if="rol == 'root' || rol == 'admin'" cols="12" xs="12" :sm="rol == 'root' ? 2 : 4" :md="rol == 'root' ? 2 : 4" class="pb-0 ma-0">
                                        <VuetifyMultipleAutocomplete
                                            outlined
                                            :items="registrosPatronales"
                                            item_text="nombreClave"
                                            item_value="id"
                                            @dataMultiple="(data) => registrosPatronalesSeleccionados = data"
                                            label="Registros patronales"
                                            ref="multRegistroPatronal"
                                            :loading="loadingRegistroPatronal"
                                            :disabled="isFormBusy"
                                        />
                                    </v-col>
                                    <v-col v-if="rol == 'root' || rol == 'admin'" cols="12" xs="12" sm="4" md="4" class="pb-0 ma-0">
                                        <VuetifyMultipleAutocomplete
                                            outlined
                                            :items="empresas"
                                            item_text="nombre"
                                            @dataMultiple="(data) => empresasSeleccionadas = data"
                                            label="Empresas"
                                            ref="multEmpresa"
                                            :loading="loadingEmpresa"
                                            :disabled="isFormBusy"
                                        />
                                    </v-col>
                                    <v-col v-if="rol == 'root' || rol == 'admin' || rol == 'admin-empresa'" cols="12" xs="12" sm="2" md="2" class="pb-0 ma-0">
                                        <VuetifyMultipleAutocomplete
                                            outlined
                                            :items="sucursales"
                                            item_text="nombre"
                                            @dataMultiple="(data) => sucursalesSeleccionadas = data"
                                            label="Sucursales"
                                            ref="multSucursal"
                                            :loading="loadingSucursales"
                                            :disabled="empresasSeleccionadas.length === 0 || loadingEmpleados || loadingDepartamentos || isFormBusy"
                                        />
                                    </v-col>
                                    <v-col v-if="rol == 'root' || rol == 'admin' || rol == 'admin-empresa'" cols="12" xs="12" sm="2" md="2" class="pb-0 ma-0">
                                        <VuetifyMultipleAutocomplete
                                            outlined
                                            :items="departamentos"
                                            item_text="nombre"
                                            @dataMultiple="(data) => departamentosSeleccionados = data"
                                            label="Departamentos"
                                            ref="multDepartamento"
                                            :loading="loadingDepartamentos"
                                            :disabled="loadingEmpleados || loadingSucursales || sucursalesSeleccionadas.length === 0 || isFormBusy"
                                        />
                                    </v-col>
                                    <v-col v-if="rol == 'root' || rol == 'admin' || rol == 'admin-empresa'" cols="12" xs="12" sm="4" md="4" class="pb-0 ma-0">
                                        <VuetifyMultipleAutocomplete
                                            outlined
                                            :items="tipos_nominas"
                                            item_text="claveDescripcion"
                                            @dataMultiple="(data) => tiposNominasSeleccionadas = data"
                                            label="Tipo de nómina"
                                            ref="multTiposNomina"
                                            :loading="loadingTiposNomina"
                                            :disabled="isFormBusy || empresasSeleccionadas.length === 0"
                                        />
                                    </v-col>
                                    <v-col v-if="rol == 'root' || rol == 'admin' || rol == 'admin-empresa'" cols="12" xs="12" sm="4" md="4" class="pb-0 ma-0">
                                        <ValidationProvider v-slot="{ errors }" name="Año fiscal" rules="required">
                                            <v-autocomplete
                                                outlined
                                                label="Año fiscal"
                                                :items="items_anios"
                                                item-text="nombre"
                                                item-value="id"
                                                persistent-hint
                                                v-model="anio_id"
                                                class="pa-0 ma-0"
                                                required
                                                :error-messages="errors"
                                                :loading="loadingAnios"
                                                :disabled="isFormBusy || empresasSeleccionadas.length === 0"
                                            />
                                        </ValidationProvider>
                                    </v-col>
                                    <v-col v-if="rol == 'root' || rol == 'admin' || rol == 'admin-empresa'" cols="12" xs="12" sm="4" md="4" class="pb-0 ma-0">
                                        <ValidationProvider v-slot="{ errors }" name="Mes" rules="required">
                                            <v-autocomplete
                                                outlined
                                                label="Mes"
                                                :items="meses"
                                                item-text="nombre"
                                                item-value="valor"
                                                persistent-hint
                                                v-model="mes_id"
                                                class="pa-0 ma-0"
                                                required
                                                :error-messages="errors"
                                                :disabled="isFormBusy"
                                            />
                                        </ValidationProvider>
                                    </v-col>
                                    <v-col v-if="rol == 'root' || rol == 'admin' || rol == 'admin-empresa'" cols="12" xs="12" sm="4" md="4" class="pb-0 ma-0">
                                        <VuetifyMultipleAutocomplete
                                            outlined
                                            :items="empleados"
                                            item_text="nombre_completo"
                                            @dataMultiple="(data) => empleadosSeleccionados = data"
                                            label="Empleados"
                                            ref="multEmpleados"
                                            :loading="loadingEmpleados"
                                            :disabled="loadingEmpleados || loadingDepartamentos || loadingSucursales || isFormBusy || !anio_id || !mes_id"
                                        />
                                    </v-col>
                                </v-row>
                            </ValidationObserver>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import apiRegistroPatronal from "@/api/nominas/registroPatronal";
import apiTipoNomina from '@/api/nominas/tipoNomina';
import clientesApi from "@/api/clientes";
import empresaApi from "@/api/empresas";
import sucursalApi from "@/api/sucursales";
import departamentoApi from "@/api/departamentos";
import apiAnios from '@/api/anual_fiscal';
import VuetifyMultipleAutocomplete from '@/components/VuetifyMultipleAutocomplete.vue';
import Notify from '@/plugins/notify';

export default {
    components: {
        VuetifyMultipleAutocomplete,
    },
    data() {
        return {
            nombre_tipo_reporte: "Reporte de Personal GMM",
            datosLogin: null,
            rol: null,
            cliente_value: null,
            overlay: false,
            fraseOverlay: "Descargando",
            clientes: [],
            registrosPatronales: [],
            empresas: [],
            sucursales: [],
            departamentos: [],
            tipos_nominas: [],
            items_anios: [],
            empleados: [],
            registrosPatronalesSeleccionados: [],
            empresasSeleccionadas: [],
            sucursalesSeleccionadas: [],
            departamentosSeleccionados: [],
            tiposNominasSeleccionadas: [],
            anio_id: null,
            mes_id: null,
            empleadosSeleccionados: [],
            loadingRegistroPatronal: false,
            loadingEmpresa: false,
            loadingSucursales: false,
            loadingDepartamentos: false,
            loadingTiposNomina: false,
            loadingAnios: false,
            loadingEmpleados: false,
            empleadosRequestId: 0,
            debounceTimeRegistroPatronal: null,
            debounceTimeEmpresas: null,
            debounceTimeSucursales: null,
            debounceTimeEmpleados: null,
            meses: [
                { nombre: "Enero", valor: 1 },
                { nombre: "Febrero", valor: 2 },
                { nombre: "Marzo", valor: 3 },
                { nombre: "Abril", valor: 4 },
                { nombre: "Mayo", valor: 5 },
                { nombre: "Junio", valor: 6 },
                { nombre: "Julio", valor: 7 },
                { nombre: "Agosto", valor: 8 },
                { nombre: "Septiembre", valor: 9 },
                { nombre: "Octubre", valor: 10 },
                { nombre: "Noviembre", valor: 11 },
                { nombre: "Diciembre", valor: 12 },
            ],
        };
    },
    computed: {
        isFormBusy() {
            return this.loadingRegistroPatronal
                || this.loadingEmpresa
                || this.loadingSucursales
                || this.loadingDepartamentos
                || this.loadingTiposNomina
                || this.loadingAnios
                || this.loadingEmpleados;
        },
    },
    watch: {
        cliente_value(val) {
            this.cambiaCliente(val);
        },
        registrosPatronalesSeleccionados: {
            deep: true,
            handler(val) {
                this.scheduleCambiaRegistroPatronal(val);
            },
        },
        empresasSeleccionadas: {
            deep: true,
            handler(val) {
                this.scheduleCambiaEmpresas(val);
            },
        },
        sucursalesSeleccionadas: {
            deep: true,
            handler(val) {
                this.departamentosSeleccionados = [];
                if (this.$refs.multDepartamento !== undefined) {
                    this.$refs.multDepartamento.setData([]);
                }
                this.scheduleCambiaSucursales(val);
            },
        },
        departamentosSeleccionados: {
            deep: true,
            handler() {
                this.scheduleCambiaDepartamentos();
            },
        },
        tiposNominasSeleccionadas: {
            deep: true,
            handler() {
                this.scheduleGetEmpleados();
            },
        },
        anio_id() {
            this.scheduleGetEmpleados();
        },
        mes_id() {
            this.scheduleGetEmpleados();
        },
    },
    methods: {
        scheduleFilterRequest(debounceKey, callback, loadingKey = null) {
            if (this[debounceKey]) {
                clearTimeout(this[debounceKey]);
            }
            if (loadingKey) {
                this[loadingKey] = true;
            }
            this[debounceKey] = setTimeout(() => {
                callback();
            }, 500);
        },

        clearAllFilterDebounceTimers() {
            ['debounceTimeRegistroPatronal', 'debounceTimeEmpresas', 'debounceTimeSucursales', 'debounceTimeEmpleados'].forEach((key) => {
                if (this[key]) {
                    clearTimeout(this[key]);
                    this[key] = null;
                }
            });
            this.loadingEmpresa = false;
            this.loadingSucursales = false;
            this.loadingDepartamentos = false;
            this.loadingEmpleados = false;
        },

        limpiarEmpleados() {
            if (this.debounceTimeEmpleados) {
                clearTimeout(this.debounceTimeEmpleados);
                this.debounceTimeEmpleados = null;
            }
            this.empleadosRequestId++;
            this.loadingEmpleados = false;
            this.empleados = [];
            this.empleadosSeleccionados = [];
            if (this.$refs.multEmpleados !== undefined) {
                this.$refs.multEmpleados.setData([]);
            }
        },

        limpiarDependientesEmpresa() {
            this.sucursalesSeleccionadas = [];
            this.departamentosSeleccionados = [];
            this.tiposNominasSeleccionadas = [];
            this.anio_id = null;
            if (this.$refs.multSucursal !== undefined) {
                this.$refs.multSucursal.setData([]);
            }
            if (this.$refs.multDepartamento !== undefined) {
                this.$refs.multDepartamento.setData([]);
            }
            if (this.$refs.multTiposNomina !== undefined) {
                this.$refs.multTiposNomina.setData([]);
            }
            this.limpiarEmpleados();
        },

        scheduleGetEmpleados() {
            if (!this.cliente_value) {
                this.limpiarEmpleados();
                return;
            }
            this.scheduleFilterRequest('debounceTimeEmpleados', () => this.peticionEmpleados(), 'loadingEmpleados');
        },

        scheduleCambiaDepartamentos() {
            this.empleadosSeleccionados = [];
            if (this.$refs.multEmpleados !== undefined) {
                this.$refs.multEmpleados.setData([]);
            }
            this.scheduleGetEmpleados();
        },

        scheduleCambiaRegistroPatronal() {
            if (this.rol != "admin-empresa") {
                this.empresasSeleccionadas = [];
                if (this.$refs.multEmpresa !== undefined) {
                    this.$refs.multEmpresa.setData([]);
                }
            }

            if (!this.cliente_value) {
                if (this.debounceTimeRegistroPatronal) {
                    clearTimeout(this.debounceTimeRegistroPatronal);
                    this.debounceTimeRegistroPatronal = null;
                }
                this.loadingEmpresa = false;
                this.empresas = [];
                return;
            }

            this.scheduleFilterRequest('debounceTimeRegistroPatronal', () => this.peticionEmpresas(), 'loadingEmpresa');
        },

        scheduleCambiaEmpresas(items) {
            if (this.debounceTimeEmpresas) {
                clearTimeout(this.debounceTimeEmpresas);
                this.debounceTimeEmpresas = null;
            }
            if (this.debounceTimeSucursales) {
                clearTimeout(this.debounceTimeSucursales);
                this.debounceTimeSucursales = null;
            }
            this.loadingSucursales = false;
            this.loadingDepartamentos = false;
            this.limpiarDependientesEmpresa();

            if (items.length === 0) {
                this.sucursales = [];
                this.departamentos = [];
                this.tipos_nominas = [];
                this.items_anios = [];
                return;
            }

            this.scheduleFilterRequest('debounceTimeEmpresas', () => {
                this.getTiposNominas();
                this.getAnios();
                this.peticionSucursales();
            }, 'loadingSucursales');
        },

        scheduleCambiaSucursales(items) {
            if (items.length === 0) {
                if (this.debounceTimeSucursales) {
                    clearTimeout(this.debounceTimeSucursales);
                    this.debounceTimeSucursales = null;
                }
                this.loadingDepartamentos = false;
                this.departamentos = [];
                this.scheduleGetEmpleados();
                return;
            }
            this.scheduleFilterRequest('debounceTimeSucursales', () => this.peticionDepartamentos(), 'loadingDepartamentos');
        },

        init() {
            this.datosLogin = this.$session.get("usuario");
            this.rol = this.datosLogin.rol.name;
            this.nombre_tipo_reporte = "Reporte de Personal GMM";

            if (this.rol == "root") {
                this.getClientes();
            } else if (this.rol == "admin") {
                this.cliente_value = this.datosLogin.cliente_id;
            } else if (this.rol == "admin-empresa") {
                this.cliente_value = this.datosLogin.cliente_id;
                this.empresasSeleccionadas = [this.datosLogin.empresa_id];
            } else {
                Notify.ErrorToast("Tu rol no tiene acceso a este módulo");
            }
        },

        peticionEmpleados() {
            if (!this.cliente_value) {
                this.empleadosRequestId++;
                this.loadingEmpleados = false;
                this.empleados = [];
                return;
            }

            if (this.anio_id == null || this.mes_id == null) {
                this.loadingEmpleados = false;
                this.empleados = [];
                return;
            }

            const requestId = ++this.empleadosRequestId;
            this.loadingEmpleados = true;
            this.empleados = [];

            const parametros = {
                paginate: false,
                cliente_id: this.cliente_value,
                tipoSolicitud: 'empleados',
                anio: this.anio_id,
                mes: this.mes_id,
            };

            if (this.tiposNominasSeleccionadas.length > 0) {
                parametros.arrayTipoNomina = JSON.stringify(this.tiposNominasSeleccionadas);
            }
            if (this.registrosPatronalesSeleccionados.length > 0) {
                parametros.arrayRegistroPatronal = JSON.stringify(this.registrosPatronalesSeleccionados);
            }
            if (this.empresasSeleccionadas.length > 0) {
                parametros.arrayEmpresa = JSON.stringify(this.empresasSeleccionadas);
            }
            if (this.sucursalesSeleccionadas.length > 0) {
                parametros.arraySucursal = JSON.stringify(this.sucursalesSeleccionadas);
            }
            if (this.departamentosSeleccionados.length > 0) {
                parametros.arrayDepartamento = JSON.stringify(this.departamentosSeleccionados);
            }

            const axios = require('axios');
            axios({
                method: 'post',
                url: 'reportes/personal-gmm',
                data: parametros,
            }).then((response) => {
                if (requestId !== this.empleadosRequestId) {
                    return;
                }
                this.loadingEmpleados = false;
                this.empleados = (response.data.data || []).map((empleado) => ({
                    ...empleado,
                    nombre_completo: [
                        empleado.nombre_completo,
                        empleado.empresa && empleado.empresa.nombre,
                        empleado.sucursal && empleado.sucursal.nombre,
                        empleado.departamento && empleado.departamento.nombre,
                    ].filter(part => part).join(' - '),
                }));
            }).catch(() => {
                if (requestId !== this.empleadosRequestId) {
                    return;
                }
                this.loadingEmpleados = false;
                Notify.ErrorToast("No se pudo realizar la petición de empleados.");
            });
        },

        async getTiposNominas() {
            this.tipos_nominas = [];
            if (!this.cliente_value || this.empresasSeleccionadas.length === 0) {
                this.loadingTiposNomina = false;
                return;
            }

            const param = {
                activo: true,
                paginate: false,
                cliente_id: this.cliente_value,
                arrayEmpresa: JSON.stringify(this.empresasSeleccionadas),
            };

            this.loadingTiposNomina = true;
            await apiTipoNomina.find(param).then((response) => {
                this.loadingTiposNomina = false;
                this.tipos_nominas = response.data;
                this.tipos_nominas.map(tipo_nomina => {
                    tipo_nomina.claveDescripcion = tipo_nomina.clave + ' - ' + tipo_nomina.descripcion + " - " + tipo_nomina.nombre_empresa;
                });
            }).catch(() => {
                this.loadingTiposNomina = false;
                Notify.ErrorToast("No se pudieron cargar los tipos de nómina");
            });
        },

        async getAnios() {
            if (!this.cliente_value || this.empresasSeleccionadas.length === 0) {
                this.items_anios = [];
                this.loadingAnios = false;
                return;
            }

            const param = {
                activo: true,
                paginate: false,
                cliente_id: this.cliente_value,
                arrayEmpresa: JSON.stringify(this.empresasSeleccionadas),
            };

            this.items_anios = [];
            this.loadingAnios = true;
            await apiAnios.empresasAnios(param).then((response) => {
                this.loadingAnios = false;
                this.items_anios = response.data;
            }).catch(() => {
                this.loadingAnios = false;
                Notify.ErrorToast("No se pudieron cargar los años fiscales");
            });
        },

        async getClientes() {
            const param = { activo: true, paginate: false };
            await clientesApi.getClientes(param).then(response => {
                this.clientes = response.data;
            }).catch(() => {
                Notify.ErrorToast("Ocurrió un error al cargar los clientes");
            });
        },

        async peticionEmpresas() {
            if (!this.cliente_value) {
                this.empresas = [];
                this.loadingEmpresa = false;
                return;
            }

            const param = {
                activo: true,
                paginate: false,
                cliente_id: this.cliente_value,
            };
            if (this.registrosPatronalesSeleccionados.length > 0) {
                param.arrayRegistroPatronal = JSON.stringify(this.registrosPatronalesSeleccionados);
            }

            this.loadingEmpresa = true;
            try {
                const response = await empresaApi.getEmpresas(param);
                this.empresas = response.data;
            } catch (err) {
                Notify.ErrorToast("Ocurrió un error al cargar las empresas.");
            } finally {
                this.loadingEmpresa = false;
            }
        },

        async peticionSucursales() {
            if (this.empresasSeleccionadas.length === 0) {
                this.sucursales = [];
                this.loadingSucursales = false;
                return;
            }

            const parametros = {
                activo: true,
                paginate: false,
                arrayEmpresa: JSON.stringify(this.empresasSeleccionadas),
            };

            this.loadingSucursales = true;
            try {
                const response = await sucursalApi.getSucursales(parametros);
                this.sucursales = response.data.map(suc => ({
                    ...suc,
                    nombre: suc.nombre + " - " + suc.nombre_empresa,
                }));
            } catch (err) {
                Notify.ErrorToast("Ocurrió un error al cargar las sucursales.");
            } finally {
                this.loadingSucursales = false;
            }
        },

        async peticionDepartamentos() {
            this.loadingDepartamentos = true;
            const parametros = {
                activo: true,
                paginate: false,
                arraySucursal: JSON.stringify(this.sucursalesSeleccionadas),
            };

            try {
                const response = await departamentoApi.getDepartamentos(parametros);
                this.departamentos = response.data.map(depto => ({
                    ...depto,
                    nombre: depto.nombre + " - " + depto.nombre_sucursal,
                }));
            } catch (err) {
                Notify.ErrorToast("Ocurrió un error al cargar los departamentos.");
            } finally {
                this.loadingDepartamentos = false;
                this.scheduleGetEmpleados();
            }
        },

        async cambiaCliente(cliente) {
            if (this.rol != "admin-empresa") {
                this.registrosPatronalesSeleccionados = [];
                this.empresasSeleccionadas = [];
                this.empresas = [];
                if (this.$refs.multRegistroPatronal !== undefined) {
                    this.$refs.multRegistroPatronal.setData([]);
                }
                if (this.$refs.multEmpresa !== undefined) {
                    this.$refs.multEmpresa.setData([]);
                }
            }
            this.sucursales = [];
            this.departamentos = [];
            this.tipos_nominas = [];
            this.items_anios = [];
            this.limpiarDependientesEmpresa();

            if (cliente == null) {
                this.registrosPatronales = [];
                return;
            }

            const param = { activo: true, paginate: false, cliente_id: cliente };
            this.loadingRegistroPatronal = true;
            try {
                const response = await apiRegistroPatronal.find(param);
                this.registrosPatronales = response.data.map(item => ({
                    ...item,
                    nombreClave: item.nombre + ' - ' + item.clave,
                }));
            } catch (err) {
                Notify.ErrorToast("Ocurrió un error al cargar los registros patronales.");
            } finally {
                this.loadingRegistroPatronal = false;
            }

            if (this.rol != "admin-empresa") {
                await this.peticionEmpresas();
            }
        },

        resetValues() {
            this.clearAllFilterDebounceTimers();
            this.loadingSucursales = false;
            this.loadingDepartamentos = false;
            this.loadingEmpleados = false;
            this.$nextTick(async () => {
                if (this.rol == "root") {
                    this.cliente_value = null;
                    this.registrosPatronales = [];
                    this.empresas = [];
                }
                if (this.rol == "root" || this.rol == "admin") {
                    this.registrosPatronalesSeleccionados = [];
                    this.empresasSeleccionadas = [];
                    if (this.$refs.multRegistroPatronal !== undefined) {
                        this.$refs.multRegistroPatronal.setData([]);
                    }
                    if (this.$refs.multEmpresa !== undefined) {
                        this.$refs.multEmpresa.setData([]);
                    }
                }
                this.sucursales = [];
                this.departamentos = [];
                this.tipos_nominas = [];
                this.items_anios = [];
                this.empleados = [];
                this.sucursalesSeleccionadas = [];
                this.departamentosSeleccionados = [];
                this.tiposNominasSeleccionadas = [];
                this.anio_id = null;
                this.mes_id = null;
                this.empleadosSeleccionados = [];

                if (this.$refs.multSucursal !== undefined) {
                    this.$refs.multSucursal.setData([]);
                }
                if (this.$refs.multDepartamento !== undefined) {
                    this.$refs.multDepartamento.setData([]);
                }
                if (this.$refs.multTiposNomina !== undefined) {
                    this.$refs.multTiposNomina.setData([]);
                }
                if (this.$refs.multEmpleados !== undefined) {
                    this.$refs.multEmpleados.setData([]);
                }

                if (this.rol == "admin-empresa") {
                    this.empresasSeleccionadas = [this.datosLogin.empresa_id];
                }

                if (this.$refs.form) {
                    this.$refs.form.reset();
                }
            });
        },

        generarReporte(type) {
            this.$refs.form.validate().then(success => {
                if (!success) {
                    return;
                }

                this.overlay = true;
                this.fraseOverlay = 'Generando reporte';
                const self = this;
                const FileDownload = require("js-file-download");
                const axios = require('axios');

                const parametros = {
                    anio: this.anio_id,
                    mes: this.mes_id,
                    tipoSolicitud: 'reporte',
                };

                if (this.registrosPatronalesSeleccionados.length > 0) {
                    parametros.arrayRegistroPatronal = this.registrosPatronalesSeleccionados;
                }
                if (this.empresasSeleccionadas.length > 0) {
                    parametros.arrayEmpresa = this.empresasSeleccionadas;
                }
                if (this.sucursalesSeleccionadas.length > 0) {
                    parametros.arraySucursal = this.sucursalesSeleccionadas;
                }
                if (this.departamentosSeleccionados.length > 0) {
                    parametros.arrayDepartamento = this.departamentosSeleccionados;
                }
                if (this.tiposNominasSeleccionadas.length > 0) {
                    parametros.arrayTipoNomina = this.tiposNominasSeleccionadas;
                }
                if (this.empleadosSeleccionados.length > 0) {
                    parametros.empleados = this.empleadosSeleccionados;
                }

                const mesObj = this.meses.find(m => m.valor === this.mes_id);
                const anioObj = this.items_anios.find(a => a.id === this.anio_id);
                const nombreMes = mesObj ? mesObj.nombre : '';
                const nombreAnio = anioObj ? anioObj.nombre : '';
                const nombre = `Formato Aseguradora_CMP_${nombreMes} ${nombreAnio}.xlsx`;

                axios({
                    method: "post",
                    url: "reportes/personal-gmm",
                    responseType: "blob",
                    data: parametros,
                }).then(function(response) {
                    self.overlay = false;
                    if (response.status == 200) {
                        FileDownload(response.data, nombre);
                    } else {
                        Notify.ErrorToast("Algo ha salido mal, intenta de nuevo o consulta a soporte técnico.");
                    }
                }).catch(async (error) => {
                    self.overlay = false;
                    let errorString = error.response.data;
                    if (
                        error.request.responseType === 'blob' &&
                        error.response.data instanceof Blob &&
                        error.response.data.type &&
                        error.response.data.type.toLowerCase().indexOf('json') != -1
                    ) {
                        errorString = JSON.parse(await error.response.data.text());

                        if (typeof errorString.error === 'string') {
                            Notify.ErrorToast(errorString.error);
                        } else {
                            const errores = Object.values(errorString.error);
                            let leyenda = ``;
                            for (let i = 0; i < errores.length; i++) {
                                leyenda += `* ` + errores[i] + `\n`;
                            }
                            Notify.ErrorToast(leyenda);
                        }
                    }
                });
            });
        },

        redireccionar() {
            this.$router.push('/dashboard');
        },
    },
    created() {
        this.init();
    },
    beforeDestroy() {
        this.clearAllFilterDebounceTimers();
    },
};
</script>

<style scoped>
    .btnReportes.theme--light.v-btn {
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 17px;
        color: #828282;
        text-transform: none;
        transition: 0.3s;
        height: 38px !important;
        background: #EFEFEF;
        border-radius: 15px;
    }

    .btnReportes.theme--light.v-btn:hover {
        background: #EFEFEF !important;
        box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08) !important;
        -webkit-box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08) !important;
        -moz-box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08) !important;
    }

    .margen {
        height: 48px;
        margin-bottom: 20px;
        margin-left: 1px;
    }

    .text-exportar {
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 18px;
        display: flex;
        letter-spacing: 0.1px;
        color: #828282;
    }

    .btnBorrar {
        font-family: "Montserrat" !important;
        font-style: normal !important;
        font-weight: 600 !important;
        font-size: 13px !important;
        line-height: 18px !important;
        background-color: #1E2245 !important;
        border-radius: 30px !important;
        color: white !important;
        height: 40px !important;
        outline: none;
        text-transform: none !important;
        margin-left: 3%;
        transition: all .2s;
    }
</style>
